import React from 'react';

// export default function FourOhFourPage() {
//   return <p>This page doesn't exist</p>;
// }
const FourOhFourPage = () => <p>This Page is out of this world ..!</p>;

export default FourOhFourPage;
